import { render, staticRenderFns } from "./news_comment_block.vue?vue&type=template&id=6e83b1c8"
import script from "./news_comment_block.vue?vue&type=script&lang=js"
export * from "./news_comment_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports